/** Valores canônicos de `Patient.sex` — ver `sexSchema` em @bookdental/schemas: "M" | "F" | "OTHER".
 *  Fica num só lugar porque já existiam duas cópias divergentes ("MALE"/"FEMALE"), que caíam no
 *  fallback e mostravam a sigla crua na tela. */
export const SEXO_LABEL: Record<string, string> = {
  M: "Masculino",
  F: "Feminino",
  OTHER: "Outro",
};

/** Versão curta, pra linha de identificação onde o espaço é apertado. */
export const SEXO_CURTO: Record<string, string> = {
  M: "M",
  F: "F",
  OTHER: "Outro",
};

export const rotuloDeSexo = (sex: string | null | undefined) => (sex ? (SEXO_LABEL[sex] ?? sex) : null);
